import validate from 'validate.js'

const constraints = {
  studentName: {
    presence: false
  },
  educatorId: {
    presence: false
  },
  students: {
    presence: true
  }
}

export default (data) => {
  return validate(data, constraints)
}
